<script>
    import $ from 'jquery'
    import {onMounted, nextTick} from 'vue'
    import { Autoplay, Navigation, Pagination } from 'swiper/modules';
    import { Swiper, SwiperSlide } from "swiper/vue";

    export default {
      components: {
        Swiper,
        SwiperSlide
        },
        setup(){
        function  pushHighlight(event, category, placement, creation = '', url = '', name = ''){
            window.dataLayer.push({
            'event': event,
            'onsitead_category': category,
            'onsitead_creation': creation,
            'onsitead_general_placement': placement,
            'onsitead_url': url,
            'onsitead_advertiser': name.replace(/["+?!]/g,'').replace(/[#_', ]/g,'_').normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
          })
        }


        onMounted(async() => {
          await nextTick();
          var sliderButtons = $('.hero-pagination .swiper-pagination-bullet');
          sliderButtons.each(function(index){
              $(this).click(function(e){
                  var carouselCreation  = 'position_' + (index + 1);
                  var elementAttribute = '.swiper-wrapper .swiper-slide[data-swiper-slide-index="' + index + '"]';
                  var carouselName = $(elementAttribute).find('.title.hero-title b').not('.swiper-slide-duplicate-prev, swiper-slide-duplicate-next').text();
                  var url = $(elementAttribute).find('.button--cta').not('.swiper-slide-duplicate-prev, swiper-slide-duplicate-next').attr('href');
                  pushHighlight('highlight_click','carousel','top', carouselCreation, url, carouselName);
                  pushHighlight('highlight_impression','carousel','top', carouselCreation, url, carouselName);
              });
          });
          var sliderArrows = $('.hero-nav');
        sliderArrows.each(function(){
          var arrow = $(this);
          arrow.click(function(e){
            var slide = $('.swiper-slide-active');
            var slideIndex = slide.data('swiper-slide-index');
            var carouselCreation  = 'position_' + (slide.data('swiper-slide-index') + 1);
            var elementAttribute = '.swiper-wrapper .swiper-slide[data-swiper-slide-index="' + slideIndex + '"]';
            var carouselName = $(elementAttribute).find('.title.hero-title b').not('.swiper-slide-duplicate-prev, swiper-slide-duplicate-next').text();
            var url = $(elementAttribute).find('.button--cta').not('.swiper-slide-duplicate-prev, swiper-slide-duplicate-next').attr('href');
            pushHighlight('highlight_click','carousel','top', carouselCreation, url, carouselName);
            pushHighlight('highlight_impression','carousel','top', carouselCreation, url, carouselName);
          });
      });
    })

    return {
      modules: [Autoplay, Navigation, Pagination],
    }
  }

}
</script>

<style lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import _hero-swiper
</style>
